"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { ArrowRight, Calendar, MapPin, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GlobalReach() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const hours = [{
    day: "MON-FRI",
    time: "0800-1900 EST"
  }, {
    day: "SAT",
    time: "BY APPOINTMENT"
  }, {
    day: "SUN",
    time: "CLOSED"
  }];
  return <section data-section-id="4436" id="global-reach" className="bg-background text-foreground py-20 md:py-32 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="font-mono text-xs md:text-sm text-primary tracking-widest">
              {"// STRATEGIC COORDINATES"}
            </span>
            <div className="h-px flex-1 max-w-[120px] bg-primary/40" />
          </div>
          <h2 className="font-default font-bold uppercase leading-[0.95] tracking-tight text-foreground" style={{
          fontSize: "clamp(2.5rem, 6vw, 6rem)"
        }}>
            CATALYST
            <span className="text-muted-foreground"> / </span>
            <span className="text-primary">HQ</span>
          </h2>
        </div>

        {}
        <div className="relative w-full h-[500px] md:h-[600px] border border-border shadow-2xl overflow-hidden">
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701027/img/catalyst_hq_map.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701027/img/catalyst_hq_map.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701027/img/catalyst_hq_map.webp-wvc-sizes" alt="Catalyst Growth Lab headquarters location" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover opacity-80" />

          {}
          <div className="absolute inset-0 opacity-20 pointer-events-none" style={{
          backgroundImage: "linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)",
          backgroundSize: "60px 60px"
        }} />

          {}
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
            <div className="relative">
              {}
              <span className="absolute inset-0 -m-6 animate-ping rounded-lg bg-primary/30" />
              <span className="absolute inset-0 -m-3 animate-pulse rounded-lg bg-primary/50" />
              {}
              <div className="relative w-8 h-8 flex items-center justify-center">
                <div className="absolute w-8 h-px bg-primary" />
                <div className="absolute h-8 w-px bg-primary" />
                <div className="w-3 h-3 bg-primary border border-background" />
              </div>
              {}
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 whitespace-nowrap">
                <span className="font-mono text-[10px] text-primary tracking-widest bg-background/80 backdrop-blur px-2 py-1 border border-primary/40">
                  CATALYST // HQ 001
                </span>
              </div>
            </div>
          </div>

          {}
          <div className="absolute top-4 left-4 md:top-6 md:left-6 w-[calc(100%-2rem)] sm:w-[380px] md:w-[420px] max-w-full">
            <div className="bg-card/40 backdrop-blur-xl border border-border shadow-2xl p-6 md:p-7">
              {}
              <div className="flex items-center gap-2 mb-4">
                <MapPin className="w-3.5 h-3.5 text-primary" />
                <span className="font-mono text-[11px] md:text-xs text-primary tracking-widest">
                  HQ 001 // METRO
                </span>
              </div>

              {}
              <h3 className="font-default font-bold text-2xl md:text-3xl text-card-foreground uppercase leading-tight mb-3">
                Catalyst Growth Lab
              </h3>

              {}
              <address className="font-default not-italic text-base md:text-lg text-card-foreground/90 leading-relaxed mb-5">
                888 Innovation Way
                <br />
                Growth City, GC 10101
              </address>

              {}
              <div className="h-px w-full bg-primary/60 mb-5" />

              {}
              <div className="space-y-2 mb-6">
                {hours.map((item, i) => <div data-index={i} key={i} className="flex items-center justify-between font-mono text-[11px] md:text-xs">
                    <span className="text-muted-foreground tracking-widest">
                      {item.day}
                    </span>
                    <span className="text-card-foreground tracking-widest">
                      // {item.time}
                    </span>
                  </div>)}
              </div>

              {}
              <div className="flex flex-col sm:flex-row gap-2.5">
                <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 font-mono text-[11px] tracking-widest uppercase h-10 px-4 shadow-lg flex-1">
                  <Link to="/ContactPage">
                    <Navigation className="w-3.5 h-3.5" />
                    Get Directions
                    <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                </Button>
                <Button asChild variant="outline" className="bg-transparent border-foreground text-foreground hover:bg-foreground hover:text-background font-mono text-[11px] tracking-widest uppercase h-10 px-4 flex-1">
                  <Link to="/ContactPage">
                    <SafeHydrate><Calendar className="w-3.5 h-3.5" /></SafeHydrate>
                    Book Strategy
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          {}
          <div className="absolute bottom-4 right-4 md:bottom-6 md:right-6">
            <div className="relative px-4 py-2 bg-background/60 backdrop-blur-md">
              {}
              <span className="absolute top-0 left-0 w-2.5 h-2.5 border-t border-l border-primary" />
              <span className="absolute top-0 right-0 w-2.5 h-2.5 border-t border-r border-primary" />
              <span className="absolute bottom-0 left-0 w-2.5 h-2.5 border-b border-l border-primary" />
              <span className="absolute bottom-0 right-0 w-2.5 h-2.5 border-b border-r border-primary" />
              <span className="font-mono text-[10px] md:text-xs text-primary tracking-widest whitespace-nowrap">
                LAT 40.7128°N // LON 74.0060°W
              </span>
            </div>
          </div>
        </div>

        {}
        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 font-mono text-[10px] md:text-xs text-muted-foreground tracking-widest">
          <span>{"// SECURE FACILITY · CONSULTATION REQUIRED"}</span>
          <span>SYS_STATUS: <span className="text-primary">ACTIVE</span></span>
        </div>
      </div>
    </section>;
}